'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showOrRefreshAds = exports.onView = exports.onCanShowAdsChange = exports.onTabFocusChange = exports.onComplete = exports.onImpression = undefined;
exports.setPubAdsConsentStatus = setPubAdsConsentStatus;
exports.slotVisibilityChangeHandler = slotVisibilityChangeHandler;
exports.addSlotVisibilityChangeListener = addSlotVisibilityChangeListener;

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _parseUtils = require('../../../utils/parseUtils');

var _parseUtils2 = _interopRequireDefault(_parseUtils);

var _adsSettings = require('../../../utils/adsSettings');

var _adsSettings2 = _interopRequireDefault(_adsSettings);

var _applicationState = require('../../../utils/applicationState');

var _adSlotManager = require('../../adSlotManager');

var _adSlotManager2 = _interopRequireDefault(_adSlotManager);

var _reporter = require('../../reporter');

var _reporter2 = _interopRequireDefault(_reporter);

var _mediaEvents = require('../../media/mediaEvents');

var _mediaEvents2 = _interopRequireDefault(_mediaEvents);

var _Events = require('../../media/Events');

var _Events2 = _interopRequireDefault(_Events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onImpression = exports.onImpression = function onImpression(e) {
  // https://developers.google.com/publisher-tag/reference#googletag.events.SlotRenderEndedEvent
  // this is emitted by googletag to indicate whether an ad was returned or not since we are using
  // slotRenderEnded Event which does NOT guarantee that an ad was injected into the slot
  // if there is no ad, then we don't want to run any of the logic
  if (e.isEmpty) {
    return;
  }

  var slot = _adSlotManager2.default.getSlotWhere(['elementId', e.slot.getSlotElementId()]);
  if (slot) {
    _mediaEvents2.default.event(_Events2.default.Media.display, _Events2.default.Status.loaded).emit({
      elementId: slot.elementId
    });
    slot.currentDimensions = (0, _map2.default)(e.size, function (s) {
      // parsing here to make sure dfp didn't return some crazy size value for us
      return _parseUtils2.default.parseSize(s);
    });
    _reporter2.default.impression(slot);
    (0, _applicationState.updateState)(_applicationState.State.isFirstInSession, false);

    // resetting videoPrerollPlayed after leave behind banner rendered
    (0, _applicationState.updateState)(_applicationState.State.videoPrerollPlayed, false);
  }
};

var onComplete = exports.onComplete = function onComplete(slotData) {
  var _this = this;

  var refreshSlot = function refreshSlot() {
    var options = (0, _applicationState.getState)(_applicationState.State.options);
    var isSlotVisibilityExperimentEnabled = _parseUtils2.default.parseBool((0, _get2.default)(options, 'ads.pauseRefresh.enabled'));
    if (isSlotVisibilityExperimentEnabled) {
      _this.slotRefreshTriggered = true;
      _this.releaseSlot(slotData.mintSlot);
      slotData.mintSlot.refresh();
    } else {
      var slotDataArray = _this.slotDataArray || [];
      (0, _forEach2.default)(slotDataArray, function (_slotData) {
        _this.releaseSlot(_slotData.mintSlot);
        _slotData.mintSlot.refresh();
      });
    }
  };
  // if focus, refresh immediately, else refresh on focus
  if (!this.slotRefreshTriggered) {
    if ((0, _applicationState.getState)(_applicationState.State.tabFocus)) {
      refreshSlot();
    } else if (!slotData.onTabFocus) {
      slotData.onTabFocus = function () {
        refreshSlot();
      };
    }
  }
};

var onTabFocusChange = exports.onTabFocusChange = function onTabFocusChange(isTabFocus) {
  if (isTabFocus) {
    (0, _forEach2.default)(this.slotDataArray, function (slotData) {
      if (slotData.onTabFocus) {
        slotData.onTabFocus();
      }
    });
  }
};

var onCanShowAdsChange = exports.onCanShowAdsChange = function onCanShowAdsChange() {
  var _this2 = this;

  if (!_adsSettings2.default.canShowAds() && this.canShowAds) {
    (0, _forEach2.default)(this.slotDataArray, function (slot) {
      _this2.clearSlot(slot.mintSlot);
      _this2.releaseSlot(slot.mintSlot);
    });
  }
  this.canShowAds = _adsSettings2.default.canShowAds();
};

var onView = exports.onView = function onView(e) {
  var slot = _adSlotManager2.default.getSlotWhere(['elementId', e.slot.getSlotElementId()]);
  if (slot) {
    _reporter2.default.view(slot);
  }
};

var showOrRefreshAds = exports.showOrRefreshAds = function showOrRefreshAds(amazonBidderEnabled, slotData, slot) {
  var _this3 = this;

  googletag.cmd.push(function () {
    if (amazonBidderEnabled) {
      apstag.setDisplayBids();
    }
    if (slotData.canRefresh) {
      googletag.pubads().refresh([slotData.dfpSlot]);
    } else {
      _this3.clearSlot(slot);
      googletag.display(slot.elementId);
      slotData.canRefresh = true;
    }
  });
};

/**
 * Sets the consent status for pubads personalized ads based on what the user's current opt-out
 * status is in the application state.
 *
 * Documentation:
 *  setRequestNonPersonalizedAds
 *  https://developers.google.com/doubleclick-gpt/reference#googletag.PubAdsService_setRequestNonPersonalizedAds
 */
function setPubAdsConsentStatus() {
  googletag.cmd.push(function () {
    // 0 for personalized ads, 1 for non-personalized ads
    // https://developers.google.com/doubleclick-gpt/reference#googletag.PubAdsService_setRequestNonPersonalizedAds
    var nonPersonalizedAds = (0, _applicationState.getState)(_applicationState.State.isOptedOut, false) ? 1 : 0;
    googletag.pubads().setRequestNonPersonalizedAds(nonPersonalizedAds);
  });
}

// exported for testing
function slotVisibilityChangeHandler(event, slotDataArray) {
  var slotData = (0, _find2.default)(slotDataArray, ['mintSlot.elementId', event.slot.getSlotElementId()]);
  var isEventFromCurrentAdUnit = (0, _get2.default)(slotData, 'mintSlot.formatDefinition.adUnitId') === event.slot.getAdUnitPath();

  if (isEventFromCurrentAdUnit) {
    // if the shouldIgnoreAdVisibilityEventOnce flag is set to true
    // then we should ignore this event for this slot and reset the flag
    if ((0, _get2.default)(slotData, 'shouldIgnoreAdVisibilityEventOnce')) {
      slotData.shouldIgnoreAdVisibilityEventOnce = false;
      return;
    }

    var isSlotTimerPaused = (0, _get2.default)(slotData, 'timer.isPaused');
    var inViewPercentage = event.inViewPercentage;
    var slotWidth = (0, _get2.default)(slotData, 'mintSlot.currentDimensions[0]');
    var slotHeight = (0, _get2.default)(slotData, 'mintSlot.currentDimensions[1]');
    var adSizeString = 'view.' + slotWidth + 'x' + slotHeight;

    if (inViewPercentage === 0 && !isSlotTimerPaused) {
      _mediaEvents2.default.event(_Events2.default.Media.display, _Events2.default.Status.paused).emit(adSizeString);
      slotData.timer.pause();
    }
    if (inViewPercentage !== 0 && isSlotTimerPaused) {
      _mediaEvents2.default.event(_Events2.default.Media.display, _Events2.default.Status.resumed).emit(adSizeString);
      slotData.timer.resume();
    }
  }
}

function addSlotVisibilityChangeListener(slotDataArray) {
  googletag.pubads().addEventListener('slotVisibilityChanged', function (event) {
    slotVisibilityChangeHandler(event, slotDataArray);
  });
}